import * as React from 'react';

export const instructionsTableHeaders: React.ReactNode[] = [
  'Column Header',
  'Required?',
  'Description of Use',
  'Input Guidelines',
  'Sample Input'
];
